import { z } from "zod";
import {
  plataformaDePublicacaoSchema,
  tipoDePublicacaoSchema,
} from "../publicacoes/publicacao.contract";

export const origemDeMidiaSchema = z.enum(["upload", "publicacao"]);
export const tipoDeArquivoAcervoSchema = z.enum(["imagem", "video"]);
export const ordenacaoDoAcervoSchema = z.enum(["recente", "nome"]);

export const midiaDaBibliotecaSchema = z.object({
  id: z.string().uuid(),
  nome: z.string(),
  mimeType: z.string().min(1),
  tamanhoBytes: z.number().int().nonnegative(),
  larguraPx: z.number().int().positive().nullable(),
  alturaPx: z.number().int().positive().nullable(),
  duracaoSegundos: z.number().int().nonnegative().nullable(),
  origem: origemDeMidiaSchema,
  favorita: z.boolean(),
  capaUrl: z.string().min(1),
  previewUrl: z.string().min(1),
  criadoEm: z.string().datetime(),
});

export const listaDeMidiasSchema = z.object({
  itens: z.array(midiaDaBibliotecaSchema),
});

export const listarMidiasQuerySchema = z
  .object({
    tipo: tipoDePublicacaoSchema.optional(),
    plataformas: z.string().optional(),
    q: z.string().optional(),
    tipoArquivo: tipoDeArquivoAcervoSchema.optional(),
    origem: origemDeMidiaSchema.optional(),
    favoritas: z.enum(["1", "true"]).optional(),
    ordenar: ordenacaoDoAcervoSchema.optional(),
  })
  .strict();

export const anexarMidiasDaBibliotecaSchema = z.object({
  ids: z.array(z.string().uuid()).min(1).max(20),
});

export const atualizarFavoritaMidiaSchema = z.object({
  favorita: z.boolean(),
});

export type OrigemDeMidia = z.infer<typeof origemDeMidiaSchema>;
export type TipoDeArquivoAcervo = z.infer<typeof tipoDeArquivoAcervoSchema>;
export type OrdenacaoDoAcervo = z.infer<typeof ordenacaoDoAcervoSchema>;
export type MidiaDaBibliotecaDto = z.infer<typeof midiaDaBibliotecaSchema>;
export type ListaDeMidiasDto = z.infer<typeof listaDeMidiasSchema>;
export type ListarMidiasQuery = z.infer<typeof listarMidiasQuerySchema>;
export type AnexarMidiasDaBibliotecaDto = z.infer<
  typeof anexarMidiasDaBibliotecaSchema
>;
export type AtualizarFavoritaMidiaDto = z.infer<
  typeof atualizarFavoritaMidiaSchema
>;
